import { FC, useState } from 'react';
import { PopUpModal } from 'shared-components';
import DatePicker from 'components/common/datePicker';
import utc from 'dayjs/plugin/utc';
import dayjs, { Dayjs } from 'dayjs';
import { ISubscriptionManagementUpdateBody } from 'interface/subscriptionManagementInterface';
import globalSubscriptionManagementService from 'services/subscriptionManagementService';
import { showNotification } from 'helper/common/commonFunctions';
import { Controller, useForm } from 'react-hook-form';
dayjs.extend(utc);

interface IProps {
  payload: ISubscriptionManagementUpdateBody | null;
  handleClose: () => void;
  onApiResponse: (_: boolean) => void;
}
interface INextBillingDate {
  NextBillingDate: Dayjs;
}

const ChangeBillingDate: FC<IProps> = ({
  payload,
  handleClose,
  onApiResponse,
}) => {
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit } = useForm<INextBillingDate>({
    defaultValues: { NextBillingDate: dayjs(payload?.NextBillingDate).tz() },
  });

  const changeBillingDate = async (data: INextBillingDate) => {
    if (!payload) return;
    setLoading(true);
    payload.NextBillingDate = data.NextBillingDate.format();
    const response =
      await globalSubscriptionManagementService.updateSubscription(payload);
    if (response?.status === 200) {
      showNotification('success', 'Next Billing Date updated successfully');
      onApiResponse(true);
      handleClose();
    } else {
      onApiResponse(false);
    }
    setLoading(false);
  };

  return (
    <>
      <PopUpModal
        open={true}
        handleClose={handleClose}
        buttons={[
          {
            buttonType: 'positive',
            buttonLabel: 'Confirm',
            form: 'ChangeBillingDate',
            type: 'submit',
            disabled: loading,
            loading: loading,
          },
        ]}
        heading={'Change Next Billing Date'}
        className="flex-container">
        <div className="popup-section">
          <form
            id="ChangeBillingDate"
            onSubmit={handleSubmit(changeBillingDate)}
            className="order-detail_refund">
            <div className="fields">
              <Controller
                name="NextBillingDate"
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => {
                  return (
                    <DatePicker
                      label="Billing Date"
                      value={value}
                      onChange={onChange}
                      minDate={
                        payload?.NextBillingDate
                          ? dayjs(payload?.NextBillingDate).tz()
                          : dayjs().tz()
                      }
                      error={error?.message}
                    />
                  );
                }}
                rules={{
                  required: 'Billing Date is required',
                  validate: value => {
                    if (value?.date()) {
                      return true;
                    }
                    return 'Invalid date';
                  },
                }}
              />
            </div>
          </form>
        </div>
      </PopUpModal>
    </>
  );
};

export default ChangeBillingDate;
